import { useLocation } from "react-router-dom";

export const menuTreeGen = (
  data = [],
  { idKey = "id", parentKey = "parentId", childrenKey = "children" } = {}
) => {
  const tree = [];
  const childrenOf = {};
  data.forEach((item) => {
    const newItem = { ...item };
    const { [idKey]: id, [parentKey]: parentId = 0 } = newItem;
    childrenOf[id] = childrenOf[id] || [];
    newItem[childrenKey] = childrenOf[id];
    parentId
      ? (childrenOf[parentId] = childrenOf[parentId] || []).push(newItem)
      : tree.push(newItem);
  });
  return tree;
};

export const useActiveMenuItem = (slug) => {
  const location = useLocation();
  if (location.pathname === slug) return "selected";
  else if (location.pathname.search(slug) !== -1) return "active";
  return false;
};
